import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import sAction from 'sAction';
import Button from '../../formElements/Button';

export default function GenerateCountriesPopup(props) {
    const module = props.data.get('params').get('module');
    const recordId = props.data.get('params').get('id');

    const clickHandler = () => {
        sAction.load();
        sAction.rest.fetchData('generateCountries', 'POST', {recordId}).then((returnData) => {
            // sAction.route();
            sAction.reloadSubpanelByWay("view", "aon_license_model_countries");
            sAction.popupHide();
            sAction.unLoad();
        }).catch((errorData) => {
            sAction.error(errorData?.text);
            sAction.unLoad();
        });
    };

    return (
        <React.Fragment>
            <div className='acmPopupContent'>
                {sAction.translate('LBL_GENERATE_COUNTRIES_DESCRIPTION', module)}
            </div>
            <div className='acmPopupButtons'>
                <Button className="hoverBlue" onClick={clickHandler}>
                    <div className="icon-duplicateIcon" />
                    {sAction.translate('LBL_GENERATE_COUNTRIES_PROCEED', module)}
                </Button>
                <Button className="hoverBlue" onClick={() => sAction.popupHide()}>
                    <div className="icon-undo" />
                    {sAction.translate('LBL_CANCEL', module)}
                </Button>
            </div>
        </React.Fragment>
    );
}

GenerateCountriesPopup.propTypes = {
    data: ImmutablePropTypes.mapContains({
        params: ImmutablePropTypes.mapContains({
            module: PropTypes.string.isRequired,
            id: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};
